export default __webpack_public_path__ + "static/media/plus.6a82a2c2.svg";